import { React, useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import DataTable from "examples/Tables/DataTable";
import AddIcon from "@mui/icons-material/Add";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import { Dropdown } from "semantic-ui-react";
import { ToastContainer, toast } from "react-toastify";
import { Stack } from "@mui/material";
import InputBase from "@mui/material/InputBase";
import Paper from "@mui/material/Paper";
import SearchIcon from "@mui/icons-material/Search";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Papa from "papaparse";
import DocumentScannerIcon from "@mui/icons-material/DocumentScanner";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import PrintIcon from "@mui/icons-material/Print";
import colors from "assets/theme/base/colors";

const { info } = colors;
const BASE_URL = process.env.REACT_APP_BASE_URL;
const token = sessionStorage.getItem("token");

const ITEM_HEIGHT = 50;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

function FeeStructure() {
  //Dialog Settings
  const [open, setOpen] = useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const [maxWidth, setMaxWidth] = useState("xl");

  const [anchorEl, setAnchorEl] = useState(null);
  const [opens, setOpens] = useState(false);
  const [currentAppId, setCurrentAppId] = useState(null);

  const handleClick = (event, appId) => {
    setAnchorEl(event.currentTarget);
    setOpens(true);
    setCurrentAppId(appId);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setOpens(false);
    setCurrentAppId(null);
  };

  //Session Storage Rendering
  var user = JSON.parse(sessionStorage.getItem("user"));
  if (user) {
    var organization_id = user.organization_id;
  } else {
    var organization_id = null;
  }

  //Variable Declarations
  const [campaign_id, setCampaignId] = useState("");
  const [campus_id, setCampusId] = useState("");
  const [department_id, setDepartmentId] = useState("");
  const [degree_id, setDegreeId] = useState("");
  const [currency_id, setCurrencyId] = useState("");
  const [program_type, setProgramType] = useState("");
  const [fee_structure_type, setFeeStructureType] = useState("");
  const [admission_category, setAdmissionCategory] = useState("");
  const [admission_sub_category, setAdmissionSubCategory] = useState("");
  const [no_of_courses, setNoOfCourses] = useState("");
  const [total_credit_hours, setTotalCreditHours] = useState("");
  const [admission_fee, setAdmissionFee] = useState("");
  const [registration_fee, setRegistrationFee] = useState("");
  const [tution_fee_per_credit_hour, setTutionFeePerCreditHour] = useState("");
  const [enrollment_fee_per_course, setEnrollmentFeePerCourse] = useState("");
  const [university_admin_charges, setUniversityAdminCharges] = useState("");
  const [examination_fee_per_course, setExaminationFeePerCourse] = useState("");
  const [medical_examination_fee, setMedicalExaminationFee] = useState("");
  const [societies_clubs_fee, setSocietiesClubsFee] = useState("");
  const [medical_diagnosis_charges, setMedicalDiagnosisCharges] = useState("");
  const [cocurricular_activities_fee, setCocurricularActivitiesFee] =
    useState("");
  const [lab_studies_fee, setLabStudiesFee] = useState("");
  const [self_finance_fee, setSelfFinanceFee] = useState("");
  const [cme_fund, setCmeFund] = useState("");
  const [pmc_registration_fee, setPmcRegistrationFee] = useState("");
  const [overseas_tution_fee, setOverseasTutionFee] = useState("");
  const [fee_discount, setFeeDiscount] = useState("");
  const [pbc_registration_fee, setPbcRegistrationFee] = useState("");
  const [withholding_tax, setWithholdingTax] = useState("");
  const [withholding_tax_applicable, setWithholdingTaxApplicable] =
    useState("1");

  const [all_fee_vouchers, setAllFeeVouchers] = useState([]);
  const [all_campaigns, setAllCampaigns] = useState([]);
  const [all_campuses, setAllCampuses] = useState([]);
  const [all_departments, setAllDepartments] = useState([]);
  const [all_degrees, setAllDegrees] = useState([]);
  const [all_currencies, setAllCurrencies] = useState([]);
  const [department_ids, setDepartmentIds] = useState([]);
  const [degree_ids, setDegreeIds] = useState([]);
  const [degrees_by_departments, setDegreesByDepartments] = useState([]);

  const [showAddFeeStructureModal, setShowAddFeeStructureModal] =
    useState(false);
  const [showDeleteFeeStructureModal, setShowDeleteFeeStructureModal] =
    useState(false);
  const [showUpdateFeeStructureModal, setShowUpdateFeeStructureModal] =
    useState(false);

  const [filter_campaign_id, setFilterCampaignId] = useState("");
  const [filter_campus_id, setFilterCampusId] = useState("");
  const [filter_department_id, setFilterDepartmentId] = useState("");

  const [selectedFeeStructure, setSelectedFeeStructure] = useState(null);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [formErrors, setFormErrors] = useState({
    campaign_id,
    campus_id,
    department_id,
    degree_id,
    currency_id,
    program_type,
    fee_structure_type,
    admission_category,
    admission_sub_category,
    no_of_courses,
    total_credit_hours,
    admission_fee,
    registration_fee,
    tution_fee_per_credit_hour,
    enrollment_fee_per_course,
    university_admin_charges,
    examination_fee_per_course,
    medical_examination_fee,
    societies_clubs_fee,
    medical_diagnosis_charges,
    cocurricular_activities_fee,
  });

  const callErrors = (
    CAMPAIGNID,
    CAMPUSID,
    DEPARTMENTID,
    DEGREEID,
    CURRENCYID,
    PROGRAMTYPE,
    FEESTRUCTURETYPE,
    ADMISSIONCATEGORY,
    ADMISSIONSUBCATEGORY,
    NOOFCOURSES,
    TOTALCREDITHOURS,
    ADMISSIONFEE,
    REGISTRATIONFEE,
    TUTIONFEEPERCREDITHOUR,
    ENROLLMENTFEEPERCOURSE,
    UNIVERSITYADMINCHARGES,
    EXAMINATIONFEEPERCOURSE,
    MEDICALEXAMINATIONFEE,
    SOCIETIESCLUBFEE,
    MEDICALDIAGNOSISCHARGES,
    COCURRICULARACTIVITIESFEE
  ) => {
    const errors = {};
    if (CAMPAIGNID === "") {
      errors.campaign_id = " * Please Select a Campaign";
    }
    if (CAMPUSID === "") {
      errors.campus_id = " * Please Select a Campus";
    }
    if (DEPARTMENTID === "") {
      errors.department_id = " * Please Select a Department";
    }
    if (DEGREEID === "") {
      errors.degree_id = " * Please Select a Degree";
    }
    if (CURRENCYID === "") {
      errors.currency_id = " * Please Select a Currency Type";
    }
    if (PROGRAMTYPE === "") {
      errors.program_type = " * Please Select a Program Type";
    }
    if (FEESTRUCTURETYPE === "") {
      errors.fee_structure_type = " * Please Select a Fee Type";
    }
    if (ADMISSIONCATEGORY === "") {
      errors.admission_category = " * Please Select Admission Category";
    }
    if (ADMISSIONSUBCATEGORY === "") {
      errors.admission_sub_category = " * Please Select Admission Sub-Category";
    }
    if (NOOFCOURSES === "") {
      errors.no_of_courses = " * Please Enter No.of Courses";
    }
    if (TOTALCREDITHOURS === "") {
      errors.total_credit_hours = " * Please Enter Total Credit Hours";
    }
    if (ADMISSIONFEE === "") {
      errors.admission_fee = " * Please Enter Admission Fee";
    }
    if (REGISTRATIONFEE === "") {
      errors.registration_fee = " * Please Enter Registration Fee";
    }
    if (TUTIONFEEPERCREDITHOUR === "") {
      errors.tution_fee_per_credit_hour =
        " * Please Enter Tution Fee Per Credit Hour";
    }
    if (ENROLLMENTFEEPERCOURSE === "") {
      errors.enrollment_fee_per_course =
        " * Please Enter Enrollment Fee Per Course";
    }
    if (UNIVERSITYADMINCHARGES === "") {
      errors.university_admin_charges =
        " * Please Enter University Admin Charges";
    }
    if (EXAMINATIONFEEPERCOURSE === "") {
      errors.examination_fee_per_course =
        " * Please Enter Examination Fee Per Course";
    }
    if (MEDICALEXAMINATIONFEE === "") {
      errors.medical_examination_fee =
        " * Please Enter Medical Examination Fee";
    }
    if (SOCIETIESCLUBFEE === "") {
      errors.societies_clubs_fee = " * Please Enter Societies Club Fee";
    }
    if (MEDICALDIAGNOSISCHARGES === "") {
      errors.medical_diagnosis_charges =
        " * Please Enter Medical Diagnostic Charges";
    }
    if (COCURRICULARACTIVITIESFEE === "") {
      errors.cocurricular_activities_fee =
        " * Please Enter Co-Curricular Activities Fee";
    }
    setFormErrors(errors);
  };

  const handleSearchKeywordChange = (e) => {
    const searchTerm = e.target.value.trim().toLowerCase();
    setSearchKeyword(searchTerm);

    if (searchTerm === "") {
      getAllFeeVouchers();
    } else {
      let filteredFeeVouchers = all_fee_vouchers.filter((fee) => {
        const idMatch =
          fee.id && fee.id.toString().toLowerCase().includes(searchTerm);
        const campaignNameMatch =
          fee.campaign_name &&
          fee.campaign_name.toLowerCase().includes(searchTerm);
        const campusNameMatch =
          fee.campus_name && fee.campus_name.toLowerCase().includes(searchTerm);
        const departmentNameMatch =
          fee.department_name &&
          fee.department_name.toLowerCase().includes(searchTerm);
        const programNameMatch =
          fee.degree_name && fee.degree_name.toLowerCase().includes(searchTerm);
        const currencyCodeMatch =
          fee.currency_code &&
          fee.currency_code.toLowerCase().includes(searchTerm);
        const programTypeMatch =
          fee.program_type &&
          fee.program_type.toLowerCase().includes(searchTerm);
        const noOfCoursesMatch =
          fee.no_of_courses &&
          fee.no_of_courses.toLowerCase().includes(searchTerm);
        const totalCreditHourMatch =
          fee.total_credit_hours &&
          fee.total_credit_hours.toLowerCase().includes(searchTerm);
        const enrollmentFeeMatch =
          fee.enrollment_fee_per_course &&
          fee.enrollment_fee_per_course.toLowerCase().includes(searchTerm);
        const categoryMatch =
          fee.admission_category &&
          fee.admission_category.toLowerCase().includes(searchTerm);
        const subCategoryMatch =
          fee.admission_sub_category &&
          fee.admission_sub_category.toLowerCase().includes(searchTerm);

        return (
          idMatch ||
          campaignNameMatch ||
          campusNameMatch ||
          departmentNameMatch ||
          programNameMatch ||
          currencyCodeMatch ||
          programTypeMatch ||
          noOfCoursesMatch ||
          totalCreditHourMatch ||
          enrollmentFeeMatch ||
          categoryMatch ||
          subCategoryMatch
        );
      });
      setAllFeeVouchers(filteredFeeVouchers);
    }
  };

  const handleFocus = (e) => {
    const { name } = e.target;

    setFormErrors((prevFormErrors) => ({
      ...prevFormErrors,
      [name]: "",
    }));
  };

  const csvcolumns = [
    { Header: "#", accessor: "serial", align: "left" },
    { Header: "Voucher ID", accessor: "id", align: "left" },
    { Header: "Campaign", accessor: "campaign_name", align: "center" },
    { Header: "Campus", accessor: "campus_name", align: "center" },
    { Header: "Department", accessor: "department_name", align: "center" },
    { Header: "Program", accessor: "degree_name", align: "center" },
    { Header: "Currency", accessor: "currency_code", align: "left" },
    { Header: "Type", accessor: "program_type", align: "center" },
    { Header: "No.Of Courses", accessor: "no_of_courses", align: "center" },
    { Header: "Total Cr.Hr", accessor: "total_credit_hours", align: "center" },
    { Header: "Admission Fee", accessor: "admission_fee", align: "center" },
    {
      Header: "Registration Fee",
      accessor: "registration_fee",
      align: "center",
    },
    {
      Header: "Enrollment Fee/ Course",
      accessor: "enrollment_fee_per_course",
      align: "center",
    },
    {
      Header: "Tution Fee/ Cr.hr",
      accessor: "tution_fee_per_credit_hour",
      align: "center",
    },
    {
      Header: "Admission Category",
      accessor: "admission_category",
      align: "center",
    },
    {
      Header: "Admission Sub-Category",
      accessor: "admission_sub_category",
      align: "center",
    },
    { Header: "Fee Type", accessor: "fee_structure_type", align: "center" },
    {
      Header: "University Admin Charges",
      accessor: "university_admin_charges",
      align: "center",
    },
    {
      Header: "Examination Fee/ Course",
      accessor: "examination_fee_per_course",
      align: "center",
    },
    {
      Header: "Medical Examination Fee",
      accessor: "medical_examination_fee",
      align: "center",
    },
    {
      Header: "Societies & Clubs Fee",
      accessor: "societies_clubs_fee",
      align: "center",
    },
    {
      Header: "Medical Diagnosis Charges",
      accessor: "medical_diagnosis_charges",
      align: "center",
    },
    {
      Header: "Co-Curricular Activities Fee",
      accessor: "cocurricular_activities_fee",
      align: "center",
    },
    { Header: "Lab Studies Fee", accessor: "lab_studies_fee", align: "center" },
    {
      Header: "Self Finance Fee",
      accessor: "self_finance_fee",
      align: "center",
    },
    { Header: "CME Fund", accessor: "cme_fund", align: "center" },
    {
      Header: "Overseas Tution Fee",
      accessor: "overseas_tution_fee",
      align: "center",
    },
    { Header: "Fee Discount", accessor: "fee_discount", align: "center" },
    {
      Header: "PBC Registration Fee",
      accessor: "pbc_registration_fee",
      align: "center",
    },
    {
      Header: "PMC Registration Fee",
      accessor: "pmc_registration_fee",
      align: "center",
    },
    {
      Header: "With-holding Tax",
      accessor: "withholding_tax",
      align: "center",
    },
  ];

  const csvrows =
    all_fee_vouchers.length > 0
      ? all_fee_vouchers.map((fee, index) => {
          return {
            serial: index + 1,
            id: fee.id,
            campaign_name: fee.campaign_name,
            campus_name: fee.campus_name,
            department_name: fee.department_name,
            degree_name: fee.degree_name,
            currency_code: fee.currency_code,
            program_type: fee.program_type,
            no_of_courses: fee.no_of_courses,
            total_credit_hours: fee.total_credit_hours,
            admission_fee: fee.admission_fee,
            registration_fee: fee.registration_fee,
            enrollment_fee_per_course: fee.enrollment_fee_per_course,
            tution_fee_per_credit_hour: fee.tution_fee_per_credit_hour,
            admission_category: fee.admission_category,
            admission_sub_category: fee.admission_sub_category,
            fee_structure_type: fee.fee_structure_type,
            university_admin_charges: fee.university_admin_charges,
            examination_fee_per_course: fee.examination_fee_per_course,
            medical_examination_fee: fee.medical_examination_fee,
            societies_clubs_fee: fee.societies_clubs_fee,
            medical_diagnosis_charges: fee.medical_diagnosis_charges,
            cocurricular_activities_fee: fee.cocurricular_activities_fee,
            lab_studies_fee: fee.lab_studies_fee,
            self_finance_fee: fee.self_finance_fee,
            cme_fund: fee.cme_fund,
            overseas_tution_fee: fee.overseas_tution_fee,
            fee_discount: fee.fee_discount,
            pbc_registration_fee: fee.pbc_registration_fee,
            pmc_registration_fee: fee.pmc_registration_fee,
            withholding_tax: fee.withholding_tax,
          };
        })
      : [
          {
            serial: null,
            id: null,
            campaign_name: null,
            campus_name: null,
            department_name: null,
            degree_name: null,
            currency_code: null,
            program_type: null,
            no_of_courses: null,
            total_credit_hours: null,
            admission_fee: null,
            registration_fee: null,
            enrollment_fee_per_course: null,
            tution_fee_per_credit_hour: null,
            admission_category: null,
            admission_sub_category: null,
            fee_structure_type: null,
            university_admin_charges: null,
            examination_fee_per_course: null,
            medical_examination_fee: null,
            societies_clubs_fee: null,
            medical_diagnosis_charges: null,
            cocurricular_activities_fee: null,
            lab_studies_fee: null,
            self_finance_fee: null,
            cme_fund: null,
            overseas_tution_fee: null,
            fee_discount: null,
            pbc_registration_fee: null,
            pmc_registration_fee: null,
            withholding_tax: null,
          },
        ];

  const handleExportCSV = () => {
    const data = [
      csvcolumns.map((col) => col.Header),
      ...csvrows.map((row) => Object.values(row)),
    ];

    const csv = Papa.unparse(data);

    const blob = new Blob([csv], { type: "text/csv" });
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = "FeeVouchers.csv";

    link.click();
  };

  const handlePrint = () => {
    window.open(`/preview-voucher`);
  };

  // GET Api calls
  const getAllFeeVouchers = async () => {
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    await fetch(BASE_URL + `/fee_voucher/get_fee_vouchers`, requestOptions)
      .then((response) => response.json())
      .then((data) => {
        setAllFeeVouchers(data.fee_vouchers);
      })
      .catch((error) => console.log(error));
  };

  const getAllCampaigns = async () => {
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    await fetch(BASE_URL + `/campaign/get_campaigns`, requestOptions)
      .then((response) => response.json())
      .then((data) => {
        setAllCampaigns(data.campaigns);
      })
      .catch((error) => console.log(error));
  };

  const getAllCampuses = async () => {
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    await fetch(BASE_URL + `/campus/get_campuses`, requestOptions)
      .then((response) => response.json())
      .then((data) => {
        setAllCampuses(data.campuses);
      })
      .catch((error) => console.log(error));
  };

  const getAllDepartments = async (value) => {
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    await fetch(
      BASE_URL + `/department/get_departments_by_campus/${value}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((data) => {
        setAllDepartments(data.departments);
      })
      .catch((error) => console.log(error));
  };

  const getAllDegrees = async (value) => {
    // console.log("vale: ", value);
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    await fetch(
      BASE_URL + `/degree/get_degrees_by_department/${value}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((data) => {
        setAllDegrees(data.degrees);
      })
      .catch((error) => console.log(error));
  };

  const getAllCurrencies = async () => {
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
    };
    await fetch(BASE_URL + `/fee_voucher/get_currencies`, requestOptions)
      .then((response) => response.json())
      .then((data) => {
        setAllCurrencies(data.currencies);
      })
      .catch((error) => console.log(error));
  };

  const getDegreesByDepartments = async (selectedDepartments) => {
    let data = { department_ids: selectedDepartments };
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(data),
    };
    await fetch(
      BASE_URL + `/degree/get_degrees_by_departments`,
      requestOptions
    )
      .then((response) => response.json())
      .then((data) => {
        setDegreesByDepartments(data.degrees);
      })
      .catch((error) => console.log(error));
  };

  const getAllFeeVouchersByFilter = async () => {
    let data = {
      campaign_id: filter_campaign_id,
      department_ids: department_ids,
      degree_ids: degree_ids,
    };
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(data),
    };
    await fetch(
      BASE_URL + `/fee_voucher/filter_fee_vouchers`,
      requestOptions
    )
      .then((response) => response.json())
      .then((data) => {
        setAllFeeVouchers(data.fee_vouchers);
      })
      .catch((error) => console.log(error));
  };

  const handleCampaign = (value) => {
    setCampaignId(value);
  };

  const handleCampus = (value) => {
    setCampusId(value);
    getAllDepartments(value);
  };

  const handleDepartment = (value) => {
    setDepartmentId(value);
    getAllDegrees(value);
  };

  const handleDegree = (value) => {
    setDegreeId(value);
  };

  const handleUpdateCampaign = (event) => {
    setSelectedFeeStructure({
      ...selectedFeeStructure,
      campaign_id: event.target.value,
    });
  };

  const handleUpdateCampus = (event) => {
    setSelectedFeeStructure({
      ...selectedFeeStructure,
      campus_id: event.target.value,
    });
    getAllDepartments(event.target.value);
  };

  const handleUpdateDepartment = (event) => {
    setSelectedFeeStructure({
      ...selectedFeeStructure,
      department_id: event.target.value,
    });
    getAllDegrees(event.target.value);
  };

  const handleUpdateDegree = (event) => {
    setSelectedFeeStructure({
      ...selectedFeeStructure,
      degree_id: event.target.value,
    });
  };

  const handleFilterCampaign = (value) => {
    setFilterCampaignId(value);
  };

  const handleFilterCampus = (value) => {
    setFilterCampusId(value);
    getAllDepartments(value);
  };

  const handleFilterDepartment = (value) => {
    setFilterDepartmentId(value);
    getAllDegrees(value);
  };

  const handleCheckboxChange = (event) => {
    setWithholdingTaxApplicable(event.target.checked ? 1 : 0);
  };

  const handleUpdateCheckboxChange = (event) => {
    setSelectedFeeStructure({
      ...selectedFeeStructure,
      withholding_tax_applicable: event.target.checked ? 1 : 0,
    });
  };

  const handleDepartments = (event, data) => {
    const { value } = data;
    const selectedDepartments = Array.isArray(value) ? value : [value];

    setDepartmentIds(selectedDepartments);
    getDegreesByDepartments(selectedDepartments);
  };

  const handleDegrees = (event, data) => {
    const { value } = data;
    const selectedDegrees = Array.isArray(value) ? value : [value];

    setDegreeIds(selectedDegrees);
  };

  const checkDebug = () => {
    getAllFeeVouchersByFilter();
  };

  // Add Functions
  const showFeeStructureAddModal = () => {
    setShowAddFeeStructureModal(true);
  };

  const handleOkAddFeeStructureModal = () => {
    if (
      campaign_id &&
      campus_id &&
      department_id &&
      degree_id &&
      currency_id &&
      program_type &&
      fee_structure_type &&
      admission_category &&
      admission_sub_category &&
      no_of_courses &&
      total_credit_hours &&
      admission_fee &&
      registration_fee &&
      tution_fee_per_credit_hour &&
      enrollment_fee_per_course &&
      university_admin_charges &&
      examination_fee_per_course &&
      medical_examination_fee &&
      societies_clubs_fee &&
      medical_diagnosis_charges &&
      cocurricular_activities_fee
    ) {
      addFeeStructure();
      setShowAddFeeStructureModal(false);
    } else {
      callErrors(
        campaign_id,
        campus_id,
        department_id,
        degree_id,
        currency_id,
        program_type,
        fee_structure_type,
        admission_category,
        admission_sub_category,
        no_of_courses,
        total_credit_hours,
        admission_fee,
        registration_fee,
        tution_fee_per_credit_hour,
        enrollment_fee_per_course,
        university_admin_charges,
        examination_fee_per_course,
        medical_examination_fee,
        societies_clubs_fee,
        medical_diagnosis_charges,
        cocurricular_activities_fee
      );
    }
  };

  const handleCancelAddFeeStructureModal = () => {
    setShowAddFeeStructureModal(false);
    setCampaignId("");
    setCampusId("");
    setDepartmentId("");
    setDegreeId("");
    setCurrencyId("");
    setProgramType("");
    setFeeStructureType("");
    setAdmissionCategory("");
    setAdmissionSubCategory("");
    setNoOfCourses("");
    setTotalCreditHours("");
    setAdmissionFee("");
    setRegistrationFee("");
    setTutionFeePerCreditHour("");
    setEnrollmentFeePerCourse("");
    setUniversityAdminCharges("");
    setExaminationFeePerCourse("");
    setMedicalExaminationFee("");
    setSocietiesClubsFee("");
    setMedicalDiagnosisCharges("");
    setCocurricularActivitiesFee("");
    setLabStudiesFee("");
    setSelfFinanceFee("");
    setCmeFund("");
    setPmcRegistrationFee("");
    setOverseasTutionFee("");
    setFeeDiscount("");
    setPbcRegistrationFee("");
    setWithholdingTax("");
    setWithholdingTaxApplicable("");
    setFormErrors({
      campaign_id: "",
      campus_id: "",
      department_id: "",
      degree_id: "",
      currency_id: "",
      program_type: "",
      fee_structure_type: "",
      admission_category: "",
      admission_sub_category: "",
      no_of_courses: "",
      total_credit_hours: "",
      admission_fee: "",
      registration_fee: "",
      tution_fee_per_credit_hour: "",
      enrollment_fee_per_course: "",
      university_admin_charges: "",
      examination_fee_per_course: "",
      medical_examination_fee: "",
      societies_clubs_fee: "",
      medical_diagnosis_charges: "",
      cocurricular_activities_fee: "",
    });
  };

  const addFeeStructure = async () => {
    let data = {
      campaign_id,
      campus_id,
      department_id,
      degree_id,
      currency_id,
      program_type,
      fee_structure_type,
      admission_category,
      admission_sub_category,
      no_of_courses,
      total_credit_hours,
      admission_fee,
      registration_fee,
      tution_fee_per_credit_hour,
      enrollment_fee_per_course,
      university_admin_charges,
      examination_fee_per_course,
      medical_examination_fee,
      societies_clubs_fee,
      medical_diagnosis_charges,
      cocurricular_activities_fee,
      lab_studies_fee,
      self_finance_fee,
      cme_fund,
      pmc_registration_fee,
      overseas_tution_fee,
      fee_discount,
      pbc_registration_fee,
      withholding_tax,
      withholding_tax_applicable,
    };

    console.log(data);
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(data),
    };

    await fetch(`${BASE_URL}/fee_voucher/add_fee_voucher`, requestOptions)
      .then((response) => response.json())
      .then((data) => {
        getAllFeeVouchers();
        toast.success("Fee Voucher Added Successfully");
      })
      .catch((error) => console.log(error))
      .finally(() => {
        setCampaignId("");
        setCampusId("");
        setDepartmentId("");
        setDegreeId("");
        setCurrencyId("");
        setProgramType("");
        setFeeStructureType("");
        setAdmissionCategory("");
        setAdmissionSubCategory("");
        setNoOfCourses("");
        setTotalCreditHours("");
        setAdmissionFee("");
        setRegistrationFee("");
        setTutionFeePerCreditHour("");
        setEnrollmentFeePerCourse("");
        setUniversityAdminCharges("");
        setExaminationFeePerCourse("");
        setMedicalExaminationFee("");
        setSocietiesClubsFee("");
        setMedicalDiagnosisCharges("");
        setCocurricularActivitiesFee("");
        setLabStudiesFee("");
        setSelfFinanceFee("");
        setCmeFund("");
        setPmcRegistrationFee("");
        setOverseasTutionFee("");
        setFeeDiscount("");
        setPbcRegistrationFee("");
        setWithholdingTax("");
        setWithholdingTaxApplicable("");
      });
  };

  // Delete Functions
  const showFeeStructureDeleteModal = () => {
    setShowDeleteFeeStructureModal(currentAppId);
  };

  const handleOkDeleteFeeStructureModal = () => {
    deleteFeeStructure(showDeleteFeeStructureModal);
    setShowDeleteFeeStructureModal(false);
  };

  const handleCancelDeleteFeeStructureModal = () => {
    setShowDeleteFeeStructureModal(false);
  };

  const deleteFeeStructure = async (id) => {
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    await fetch(
      `${BASE_URL}/fee_voucher/delete_fee_voucher/${id}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((data) => {
        getAllFeeVouchers();
        toast.success("Fee Voucher Deleted Successfully");
      })
      .catch((error) => console.log(error));
  };

  // Update Functions
  const showFeeStructureUpdateModal = () => {
    const feeStructureToUpdate = all_fee_vouchers.find(
      (fee) => fee.id === currentAppId
    );
    setSelectedFeeStructure(feeStructureToUpdate);
    setShowUpdateFeeStructureModal(currentAppId);
  };

  const handleOkUpdateFeeStructureModal = () => {
    if (
      selectedFeeStructure.campaign_id &&
      selectedFeeStructure.campus_id &&
      selectedFeeStructure.department_id &&
      selectedFeeStructure.degree_id &&
      selectedFeeStructure.currency_id &&
      selectedFeeStructure.program_type &&
      selectedFeeStructure.fee_structure_type &&
      selectedFeeStructure.admission_category &&
      selectedFeeStructure.admission_sub_category &&
      selectedFeeStructure.no_of_courses &&
      selectedFeeStructure.total_credit_hours &&
      selectedFeeStructure.admission_fee &&
      selectedFeeStructure.registration_fee &&
      selectedFeeStructure.tution_fee_per_credit_hour &&
      selectedFeeStructure.enrollment_fee_per_course &&
      selectedFeeStructure.university_admin_charges &&
      selectedFeeStructure.examination_fee_per_course &&
      selectedFeeStructure.medical_examination_fee &&
      selectedFeeStructure.societies_clubs_fee &&
      selectedFeeStructure.medical_diagnosis_charges &&
      selectedFeeStructure.cocurricular_activities_fee
    ) {
      updateFeeStructure(showUpdateFeeStructureModal);
      setShowUpdateFeeStructureModal(false);
    } else {
      callErrors(
        selectedFeeStructure.campaign_id,
        selectedFeeStructure.campus_id,
        selectedFeeStructure.department_id,
        selectedFeeStructure.degree_id,
        selectedFeeStructure.currency_id,
        selectedFeeStructure.program_type,
        selectedFeeStructure.fee_structure_type,
        selectedFeeStructure.admission_category,
        selectedFeeStructure.admission_sub_category,
        selectedFeeStructure.no_of_courses,
        selectedFeeStructure.total_credit_hours,
        selectedFeeStructure.admission_fee,
        selectedFeeStructure.registration_fee,
        selectedFeeStructure.tution_fee_per_credit_hour,
        selectedFeeStructure.enrollment_fee_per_course,
        selectedFeeStructure.university_admin_charges,
        selectedFeeStructure.examination_fee_per_course,
        selectedFeeStructure.medical_examination_fee,
        selectedFeeStructure.societies_clubs_fee,
        selectedFeeStructure.medical_diagnosis_charges,
        selectedFeeStructure.cocurricular_activities_fee
      );
    }
  };

  const handleCancelUpdateFeeStructureModal = () => {
    setShowUpdateFeeStructureModal(false);
    setCampaignId("");
    setCampusId("");
    setDepartmentId("");
    setDegreeId("");
    setCurrencyId("");
    setProgramType("");
    setFeeStructureType("");
    setAdmissionCategory("");
    setAdmissionSubCategory("");
    setNoOfCourses("");
    setTotalCreditHours("");
    setAdmissionFee("");
    setRegistrationFee("");
    setTutionFeePerCreditHour("");
    setEnrollmentFeePerCourse("");
    setUniversityAdminCharges("");
    setExaminationFeePerCourse("");
    setMedicalExaminationFee("");
    setSocietiesClubsFee("");
    setMedicalDiagnosisCharges("");
    setCocurricularActivitiesFee("");
    setLabStudiesFee("");
    setSelfFinanceFee("");
    setCmeFund("");
    setPmcRegistrationFee("");
    setOverseasTutionFee("");
    setFeeDiscount("");
    setPbcRegistrationFee("");
    setWithholdingTax("");
    setWithholdingTaxApplicable("");
    setFormErrors({
      campaign_id: "",
      campus_id: "",
      department_id: "",
      degree_id: "",
      currency_id: "",
      program_type: "",
      fee_structure_type: "",
      admission_category: "",
      admission_sub_category: "",
      no_of_courses: "",
      total_credit_hours: "",
      admission_fee: "",
      registration_fee: "",
      tution_fee_per_credit_hour: "",
      enrollment_fee_per_course: "",
      university_admin_charges: "",
      examination_fee_per_course: "",
      medical_examination_fee: "",
      societies_clubs_fee: "",
      medical_diagnosis_charges: "",
      cocurricular_activities_fee: "",
    });
  };

  const updateFeeStructure = async () => {
    if (selectedFeeStructure) {
      let data = {
        id: selectedFeeStructure.id,
        campaign_id: selectedFeeStructure.campaign_id,
        campus_id: selectedFeeStructure.campus_id,
        department_id: selectedFeeStructure.department_id,
        degree_id: selectedFeeStructure.degree_id,
        currency_id: selectedFeeStructure.currency_id,
        program_type: selectedFeeStructure.program_type,
        fee_structure_type: selectedFeeStructure.fee_structure_type,
        admission_category: selectedFeeStructure.admission_category,
        admission_sub_category: selectedFeeStructure.admission_sub_category,
        no_of_courses: selectedFeeStructure.no_of_courses,
        total_credit_hours: selectedFeeStructure.total_credit_hours,
        admission_fee: selectedFeeStructure.admission_fee,
        registration_fee: selectedFeeStructure.registration_fee,
        tution_fee_per_credit_hour:
          selectedFeeStructure.tution_fee_per_credit_hour,
        enrollment_fee_per_course:
          selectedFeeStructure.enrollment_fee_per_course,
        university_admin_charges: selectedFeeStructure.university_admin_charges,
        examination_fee_per_course:
          selectedFeeStructure.examination_fee_per_course,
        medical_examination_fee: selectedFeeStructure.medical_examination_fee,
        societies_clubs_fee: selectedFeeStructure.societies_clubs_fee,
        medical_diagnosis_charges:
          selectedFeeStructure.medical_diagnosis_charges,
        cocurricular_activities_fee:
          selectedFeeStructure.cocurricular_activities_fee,
        lab_studies_fee: selectedFeeStructure.lab_studies_fee,
        self_finance_fee: selectedFeeStructure.self_finance_fee,
        cme_fund: selectedFeeStructure.cme_fund,
        pmc_registration_fee: selectedFeeStructure.pmc_registration_fee,
        overseas_tution_fee: selectedFeeStructure.overseas_tution_fee,
        fee_discount: selectedFeeStructure.fee_discount,
        pbc_registration_fee: selectedFeeStructure.pbc_registration_fee,
        withholding_tax: selectedFeeStructure.withholding_tax,
        withholding_tax_applicable:
          selectedFeeStructure.withholding_tax_applicable,
      };
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(data),
      };
      await fetch(
        `${BASE_URL}/fee_voucher/update_fee_voucher`,
        requestOptions
      )
        .then((response) => response.json())
        .then((data) => {
          getAllFeeVouchers();
          toast.success("Fee Voucher Updated Successfully");
        })
        .catch((error) => console.log(error))
        .finally(() => {
          setCampaignId("");
          setCampusId("");
          setDepartmentId("");
          setDegreeId("");
          setCurrencyId("");
          setProgramType("");
          setFeeStructureType("");
          setAdmissionCategory("");
          setAdmissionSubCategory("");
          setNoOfCourses("");
          setTotalCreditHours("");
          setAdmissionFee("");
          setRegistrationFee("");
          setTutionFeePerCreditHour("");
          setEnrollmentFeePerCourse("");
          setUniversityAdminCharges("");
          setExaminationFeePerCourse("");
          setMedicalExaminationFee("");
          setSocietiesClubsFee("");
          setMedicalDiagnosisCharges("");
          setCocurricularActivitiesFee("");
          setLabStudiesFee("");
          setSelfFinanceFee("");
          setCmeFund("");
          setPmcRegistrationFee("");
          setOverseasTutionFee("");
          setFeeDiscount("");
          setPbcRegistrationFee("");
          setWithholdingTax("");
          setWithholdingTaxApplicable("");
        });
    }
  };

  const columns = [
    { Header: "Sr.No", accessor: "serial", align: "center" },
    { Header: "ID", accessor: "id", align: "left" },
    { Header: "Campaign", accessor: "campaign", align: "center" },
    { Header: "Campus", accessor: "campus", align: "center" },
    { Header: "Department", accessor: "department", align: "center" },
    { Header: "Program", accessor: "program", align: "center" },
    { Header: "Currency", accessor: "currency", align: "left" },
    { Header: "Type", accessor: "type", align: "center" },
    { Header: "Courses", accessor: "courses", align: "center" },
    { Header: "Total Cr.Hr", accessor: "total_credit_hour", align: "center" },
    { Header: "Enrollment Fee", accessor: "enrollment_fee", align: "center" },
    { Header: "Category", accessor: "category", align: "center" },
    { Header: "Sub-Category", accessor: "sub_category", align: "center" },
    { Header: "Actions", accessor: "actions", align: "center" },
  ];

  const rows =
    all_fee_vouchers.length > 0
      ? all_fee_vouchers.map((fee, index) => {
          return {
            serial: index + 1,
            id: fee.id,
            campaign: fee.campaign_name,
            campus: fee.campus_name,
            department: fee.department_name,
            program: fee.degree_name,
            currency: fee.currency_code,
            type: fee.program_type,
            courses: fee.no_of_courses,
            total_credit_hour: fee.total_credit_hours,
            enrollment_fee: fee.enrollment_fee_per_course,
            category: fee.admission_category,
            sub_category: fee.admission_sub_category,
            actions: (
              <>
                <div>
                  <IconButton
                    aria-label="more"
                    id={`long-button-${index}`}
                    aria-controls={opens ? "long-menu" : undefined}
                    aria-expanded={opens ? "true" : undefined}
                    aria-haspopup="true"
                    onClick={(event) => handleClick(event, fee.id)}
                  >
                    <MoreVertIcon />
                  </IconButton>
                  <Menu
                    id="long-menu"
                    anchorEl={anchorEl}
                    open={opens}
                    onClose={handleClose}
                  >
                    <MenuItem onClick={showFeeStructureDeleteModal}>
                      <DeleteIcon
                        style={{ marginRight: "15px", color: "red" }}
                      />{" "}
                      Delete
                    </MenuItem>
                    <MenuItem onClick={showFeeStructureUpdateModal}>
                      <EditIcon
                        style={{ marginRight: "15px", color: "green" }}
                      />{" "}
                      Edit
                    </MenuItem>
                    <MenuItem onClick={handlePrint}>
                      <PrintIcon
                        style={{ marginRight: "15px", color: "green" }}
                      />{" "}
                      Print Voucher
                    </MenuItem>
                  </Menu>
                </div>
              </>
            ),
          };
        })
      : [
          {
            serial: null,
            id: null,
            campaign: null,
            campus: null,
            department: null,
            program: null,
            currency: null,
            type: null,
            courses: null,
            total_credit_hour: null,
            enrollment_fee: null,
            category: null,
            sub_category: null,
            actions: null,
          },
        ];

  // Initial Renderings
  useEffect(() => {
    // getAllFeeVouchers();
    getAllCampaigns();
    getAllCampuses();
    getAllCurrencies();
  }, []);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <ToastContainer />
      <MDBox pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Stack
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              spacing={1}
              paddingRight={3}
            >
              <div className="col-md-3">
                <label>Campaign</label>
                <Dropdown
                  id="filter_campaign_id"
                  name="filter_campaign_id"
                  placeholder="Select Campaign"
                  fluid
                  selection
                  search
                  value={filter_campaign_id}
                  onChange={(e, { value }) => handleFilterCampaign(value)}
                  options={all_campaigns.map((camp) => ({
                    key: camp.id,
                    text: camp.name,
                    value: camp.id,
                  }))}
                />
              </div>

              <div className="col-md-3">
                <label>Campus</label>
                <Dropdown
                  id="filter_campus_id"
                  name="filter_campus_id"
                  placeholder="Select Campus"
                  fluid
                  selection
                  search
                  value={filter_campus_id}
                  onChange={(e, { value }) => handleFilterCampus(value)}
                  options={all_campuses.map((camp) => ({
                    key: camp.id,
                    text: camp.name,
                    value: camp.id,
                  }))}
                />
              </div>

              <div className="col-md-3">
                <label>Department</label>
                <Dropdown
                  id="filter_department_id"
                  name="filter_department_id"
                  placeholder="Select Departments"
                  fluid
                  multiple={true}
                  search
                  selection
                  value={department_ids}
                  onChange={handleDepartments}
                  options={all_departments.map((dept) => ({
                    key: dept.id,
                    text: dept.department_name,
                    value: dept.department_id,
                  }))}
                />
              </div>

              <div className="col-md-3">
                <label>Degree</label>
                <Dropdown
                  id="filter_degree_id"
                  name="filter_degree_id"
                  placeholder="Select Degrees"
                  fluid
                  multiple={true}
                  search
                  selection
                  value={degree_ids}
                  onChange={handleDegrees}
                  options={degrees_by_departments.map((deg) => ({
                    key: deg.id,
                    text: deg.program_name,
                    value: deg.id,
                  }))}
                />
              </div>
            </Stack>

            <Stack
              direction="row"
              justifyContent="flex-end"
              alignItems="center"
              className="mt-3"
            >
              {/* <Paper
                                component="form"
                                sx={{ p: '2px 4px', display: 'flex', alignItems: 'center', width: 400 }}
                            >
                                <InputBase
                                    sx={{ ml: 1, flex: 1 }}
                                    placeholder="Search"
                                    inputProps={{ 'aria-label': 'search voucher' }}
                                    value={searchKeyword}
                                    onChange={handleSearchKeywordChange}
                                />
                                <SearchIcon />
                            </Paper> */}

              <Button
                variant="contained"
                endIcon={
                  <SearchIcon
                    sx={{ width: "22px", height: "22px", marginLeft: "22px" }}
                  />
                }
                onClick={checkDebug}
                style={{
                  borderColor: "white",
                  fontWeight: 500,
                  height: "40px",
                  fontSize: "16px",
                  color: "white",
                }}
              >
                Fetch Data
              </Button>
            </Stack>

            <Card
              className="mt-5"
              sx={{
                boxShadow: "none",
                border: "1px solid #DADADAEE",
                borderRadius: "5px",
              }}
            >
              <MDBox
                mx={0}
                mt={0}
                py={2}
                px={2}
                variant="gradient"
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <Stack
                  direction="row"
                  justifyContent="flex-end"
                  alignItems="center"
                  spacing={1}
                  sx={{ width: "100%" }}
                >
                  <Stack sx={{ flexGrow: 1 }}>
                    <Paper
                      component="form"
                      sx={{
                        p: "2px 4px",
                        display: "flex",
                        alignItems: "center",
                        width: "333px",
                        border: "1px solid #8C8C8C",
                        boxShadow: "none",
                      }}
                    >
                      <InputBase
                        sx={{ ml: 1, flex: 1, fontSize: "16px" }}
                        placeholder="Search"
                        inputProps={{ "aria-label": "search voucher" }}
                        value={searchKeyword}
                        onChange={handleSearchKeywordChange}
                      />
                      <SearchIcon
                        sx={{ color: "gray", width: "22px", height: "22px" }}
                      />
                    </Paper>
                  </Stack>
                  <Button
                    variant="outlined"
                    endIcon={
                      <AddIcon
                        sx={{
                          width: "22px",
                          height: "22px",
                          marginLeft: "22px",
                        }}
                      />
                    }
                    onClick={showFeeStructureAddModal}
                    style={{
                      color: "white",
                      background: info.main,
                      fontWeight: 500,
                      height: "40px",
                      fontSize: "16px",
                    }}
                  >
                    Create new
                  </Button>
                  <Button
                    variant="outlined"
                    endIcon={<DocumentScannerIcon  sx={{width: "22px", height: "22px",  marginLeft: "22px", }} />}
                    onClick={() => {
                      handleExportCSV();
                    }}
                    style={{
                      color: "white",
                      background: info.main,
                      fontWeight: 500,
                      height: '40px',
                      fontSize: "16px",
                    }}
                  >
                    Export CSV
                  </Button>
                </Stack>
              </MDBox>
              <MDBox pt={3}>
                {all_fee_vouchers && all_fee_vouchers.length > 0 ? (
                  <DataTable
                    table={{ columns, rows }}
                    isSorted={false}
                    entriesPerPage={false}
                    showTotalEntries={false}
                    noEndBorder
                  />
                ) : (
                  <div style={{ textAlign: "center" }}>
                    <img
                      src="nodata.png"
                      style={{
                        display: "block",
                        margin: "auto",
                        width: "20%",
                        height: "20%",
                      }}
                    />
                  </div>
                )}
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>

      <Dialog
        fullScreen={fullScreen}
        maxWidth={maxWidth}
        open={showAddFeeStructureModal}
        onClose={handleCancelAddFeeStructureModal}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">
          {"Create Fee Structure"}
        </DialogTitle>
        <DialogContent>
          <div className="row">
            <div className="col-md-6">
              <div className="form-outline mt-3">
                <label>Campaign</label>
                <Dropdown
                  id="campaign_id"
                  name="campaign_id"
                  placeholder="Select Campaign"
                  fluid
                  selection
                  value={campaign_id}
                  onChange={(e, { value }) => handleCampaign(value)}
                  options={all_campaigns.map((camp) => ({
                    key: camp.id,
                    text: camp.name,
                    value: camp.id,
                  }))}
                />
              </div>
              <div style={{ color: "red" }}>{formErrors.campaign_id}</div>
            </div>
            <div className="col-md-6"></div>

            <div className="col-md-4">
              <div className="form-outline mt-3">
                <label>Campus</label>
                <Dropdown
                  id="campus_id"
                  name="campus_id"
                  placeholder="Select Campus"
                  fluid
                  selection
                  value={campus_id}
                  onChange={(e, { value }) => handleCampus(value)}
                  options={all_campuses.map((camp) => ({
                    key: camp.id,
                    text: camp.name,
                    value: camp.id,
                  }))}
                />
              </div>
              <div style={{ color: "red" }}>{formErrors.campus_id}</div>
            </div>

            <div className="col-md-4">
              <div className="form-outline mt-3">
                <label>Departments</label>
                <Dropdown
                  id="department_id"
                  name="department_id"
                  placeholder="Select Department"
                  fluid
                  selection
                  value={department_id}
                  onChange={(e, { value }) => handleDepartment(value)}
                  options={all_departments.map((dept) => ({
                    key: dept.id,
                    text: dept.department_name,
                    value: dept.department_id,
                  }))}
                />
              </div>
              <div style={{ color: "red" }}>{formErrors.department_id}</div>
            </div>

            <div className="col-md-4">
              <div className="form-outline mt-3">
                <label>Degrees</label>
                <Dropdown
                  id="degree_id"
                  name="degree_id"
                  placeholder="Select Degree"
                  fluid
                  selection
                  value={degree_id}
                  onChange={(e, { value }) => handleDegree(value)}
                  options={all_degrees.map((deg) => ({
                    key: deg.id,
                    text: deg.program_name,
                    value: deg.id,
                  }))}
                />
              </div>
              <div style={{ color: "red" }}>{formErrors.degree_id}</div>
            </div>

            <div className="col-md-4">
              <div className="form-outline mt-3">
                <label>Collection Bank Account</label>
                <Dropdown
                  id="degree_id"
                  name="degree_id"
                  placeholder="Select Degree"
                  fluid
                  selection
                  value={degree_id}
                  onChange={(e, { value }) => handleDegree(value)}
                  options={all_degrees.map((deg) => ({
                    key: deg.id,
                    text: deg.program_name,
                    value: deg.id,
                  }))}
                />
              </div>
              <div style={{ color: "red" }}>{formErrors.degree_id}</div>
            </div>

            <div className="col-md-4">
              <div className="form-outline mt-3">
                <label>Currency</label>
                <Dropdown
                  id="currency_id"
                  name="currency_id"
                  placeholder="Select Currency"
                  fluid
                  selection
                  value={currency_id}
                  onChange={(e, { value }) => setCurrencyId(value)}
                  options={all_currencies.map((curr) => ({
                    key: curr.id,
                    text: curr.symbol + " " + curr.code + " - " + curr.name,
                    value: curr.id,
                  }))}
                />
              </div>
              <div style={{ color: "red" }}>{formErrors.currency_id}</div>
            </div>

            <div className="col-md-4">
              <div className="form-outline mt-3">
                <label>Program Type</label>
                <Dropdown
                  id="program_type"
                  name="program_type"
                  placeholder="Select Program Type "
                  fluid
                  selection
                  value={program_type}
                  onChange={(e, { value }) => setProgramType(value)}
                  options={[
                    {
                      key: "",
                      text: "",
                      value: "",
                    },
                    {
                      key: "1",
                      text: "Semester",
                      value: "Semester",
                    },
                    {
                      key: "2",
                      text: "Annual",
                      value: "Annual",
                    },
                    {
                      key: "3",
                      text: "Medical",
                      value: "Medical",
                    },
                    {
                      key: "4",
                      text: "Certificate",
                      value: "Certificate",
                    },
                  ]}
                />
                <div style={{ color: "red" }}>{formErrors.program_type}</div>
              </div>
            </div>

            <div className="col-md-4">
              <div className="form-outline mt-3">
                <label>Fee Structure Type</label>
                <Dropdown
                  id="fee_structure_type"
                  name="fee_structure_type"
                  placeholder="Select Fee Structure Type "
                  fluid
                  selection
                  value={fee_structure_type}
                  onChange={(e, { value }) => setFeeStructureType(value)}
                  options={[
                    {
                      key: "",
                      text: "",
                      value: "",
                    },
                    {
                      key: "1",
                      text: "Local",
                      value: "Local",
                    },
                    {
                      key: "2",
                      text: "International",
                      value: "International",
                    },
                  ]}
                />
                <div style={{ color: "red" }}>
                  {formErrors.fee_structure_type}
                </div>
              </div>
            </div>

            <div className="col-md-4">
              <div className="form-outline mt-3">
                <label>Admission Category</label>
                <Dropdown
                  id="admission_category"
                  name="admission_category"
                  placeholder="Select Admission Category "
                  fluid
                  selection
                  value={admission_category}
                  onChange={(e, { value }) => setAdmissionCategory(value)}
                  options={[
                    {
                      key: "",
                      text: "",
                      value: "",
                    },
                    {
                      key: "1",
                      text: "Regular",
                      value: "Regular",
                    },
                    {
                      key: "2",
                      text: "Self Finance",
                      value: "Self Finance",
                    },
                    {
                      key: "3",
                      text: "International",
                      value: "International",
                    },
                    {
                      key: "4",
                      text: "Other Quota",
                      value: "Other Quota",
                    },
                  ]}
                />
                <div style={{ color: "red" }}>
                  {formErrors.admission_category}
                </div>
              </div>
            </div>

            <div className="col-md-4">
              <div className="form-outline mt-3">
                <label>Admission Sub-Category</label>
                <Dropdown
                  id="admission_sub_category"
                  name="admission_sub_category"
                  placeholder="Select Admission Sub-Category "
                  fluid
                  selection
                  value={admission_sub_category}
                  onChange={(e, { value }) => setAdmissionSubCategory(value)}
                  options={[
                    {
                      key: "",
                      text: "",
                      value: "",
                    },
                    {
                      key: "1",
                      text: "Medical Graduate",
                      value: "Medical Graduate",
                    },
                    {
                      key: "2",
                      text: "PMDC",
                      value: "PMDC",
                    },
                    {
                      key: "3",
                      text: "HEC-Afghan",
                      value: "HEC-Afghan",
                    },
                    {
                      key: "4",
                      text: "NSCE",
                      value: "NSCE",
                    },
                    {
                      key: "5",
                      text: "SBSC",
                      value: "SBSC",
                    },
                    {
                      key: "6",
                      text: "Sports",
                      value: "Sports",
                    },
                  ]}
                />
                <div style={{ color: "red" }}>
                  {formErrors.admission_sub_category}
                </div>
              </div>
            </div>

            <div className="col-md-3">
              <div className="form-outline mt-3">
                <label>No Of Courses</label>
                <input
                  name="no_of_courses"
                  type="text"
                  value={no_of_courses}
                  onChange={(e) => setNoOfCourses(e.target.value)}
                  onFocus={handleFocus}
                  className="form-control form-control-lg"
                />
              </div>
              <div style={{ color: "red" }}>{formErrors.no_of_courses}</div>
            </div>

            <div className="col-md-3">
              <div className="form-outline mt-3">
                <label>Total Cr.Hours</label>
                <input
                  name="total_credit_hours"
                  type="text"
                  value={total_credit_hours}
                  onChange={(e) => setTotalCreditHours(e.target.value)}
                  onFocus={handleFocus}
                  className="form-control form-control-lg"
                />
              </div>
              <div style={{ color: "red" }}>
                {formErrors.total_credit_hours}
              </div>
            </div>

            <div className="col-md-3">
              <div className="form-outline mt-3">
                <label>Admission Fee</label>
                <input
                  name="admission_fee"
                  type="text"
                  value={admission_fee}
                  onChange={(e) => setAdmissionFee(e.target.value)}
                  onFocus={handleFocus}
                  className="form-control form-control-lg"
                />
              </div>
              <div style={{ color: "red" }}>{formErrors.admission_fee}</div>
            </div>

            <div className="col-md-3">
              <div className="form-outline mt-3">
                <label>Registration Fee</label>
                <input
                  name="registration_fee"
                  type="text"
                  value={registration_fee}
                  onChange={(e) => setRegistrationFee(e.target.value)}
                  onFocus={handleFocus}
                  className="form-control form-control-lg"
                />
              </div>
              <div style={{ color: "red" }}>{formErrors.registration_fee}</div>
            </div>

            <div className="col-md-3">
              <div className="form-outline mt-3">
                <label>Tution Fee Per Cr.Hour</label>
                <input
                  name="tution_fee_per_credit_hour"
                  type="text"
                  value={tution_fee_per_credit_hour}
                  onChange={(e) => setTutionFeePerCreditHour(e.target.value)}
                  onFocus={handleFocus}
                  className="form-control form-control-lg"
                />
              </div>
              <div style={{ color: "red" }}>
                {formErrors.tution_fee_per_credit_hour}
              </div>
            </div>

            <div className="col-md-3">
              <div className="form-outline mt-3">
                <label>Enrollment Fee Per Course</label>
                <input
                  name="enrollment_fee_per_course"
                  type="text"
                  value={enrollment_fee_per_course}
                  onChange={(e) => setEnrollmentFeePerCourse(e.target.value)}
                  onFocus={handleFocus}
                  className="form-control form-control-lg"
                />
              </div>
              <div style={{ color: "red" }}>
                {formErrors.enrollment_fee_per_course}
              </div>
            </div>

            <div className="col-md-3">
              <div className="form-outline mt-3">
                <label>University Admin Charges</label>
                <input
                  name="university_admin_charges"
                  type="text"
                  value={university_admin_charges}
                  onChange={(e) => setUniversityAdminCharges(e.target.value)}
                  onFocus={handleFocus}
                  className="form-control form-control-lg"
                />
              </div>
              <div style={{ color: "red" }}>
                {formErrors.university_admin_charges}
              </div>
            </div>

            <div className="col-md-3">
              <div className="form-outline mt-3">
                <label>Examination Fee Per Course</label>
                <input
                  name="examination_fee_per_course"
                  type="text"
                  value={examination_fee_per_course}
                  onChange={(e) => setExaminationFeePerCourse(e.target.value)}
                  onFocus={handleFocus}
                  className="form-control form-control-lg"
                />
              </div>
              <div style={{ color: "red" }}>
                {formErrors.examination_fee_per_course}
              </div>
            </div>

            <div className="col-md-3">
              <div className="form-outline mt-3">
                <label>Medical Examination Fee</label>
                <input
                  name="medical_examination_fee"
                  type="text"
                  value={medical_examination_fee}
                  onChange={(e) => setMedicalExaminationFee(e.target.value)}
                  onFocus={handleFocus}
                  className="form-control form-control-lg"
                />
              </div>
              <div style={{ color: "red" }}>
                {formErrors.medical_examination_fee}
              </div>
            </div>

            <div className="col-md-3">
              <div className="form-outline mt-3">
                <label>Societies & Club Fee</label>
                <input
                  name="societies_clubs_fee"
                  type="text"
                  value={societies_clubs_fee}
                  onChange={(e) => setSocietiesClubsFee(e.target.value)}
                  onFocus={handleFocus}
                  className="form-control form-control-lg"
                />
              </div>
              <div style={{ color: "red" }}>
                {formErrors.societies_clubs_fee}
              </div>
            </div>

            <div className="col-md-3">
              <div className="form-outline mt-3">
                <label>Medical Diagnosis Charges</label>
                <input
                  name="medical_diagnosis_charges"
                  type="text"
                  value={medical_diagnosis_charges}
                  onChange={(e) => setMedicalDiagnosisCharges(e.target.value)}
                  onFocus={handleFocus}
                  className="form-control form-control-lg"
                />
              </div>
              <div style={{ color: "red" }}>
                {formErrors.medical_diagnosis_charges}
              </div>
            </div>

            <div className="col-md-3">
              <div className="form-outline mt-3">
                <label>Co-curricular Activities Fee</label>
                <input
                  name="cocurricular_activities_fee"
                  type="text"
                  value={cocurricular_activities_fee}
                  onChange={(e) => setCocurricularActivitiesFee(e.target.value)}
                  onFocus={handleFocus}
                  className="form-control form-control-lg"
                />
              </div>
              <div style={{ color: "red" }}>
                {formErrors.cocurricular_activities_fee}
              </div>
            </div>

            <div className="col-md-3">
              <div className="form-outline mt-3">
                <label>Lab Studies Fee</label>
                <input
                  name="lab_studies_fee"
                  type="text"
                  value={lab_studies_fee}
                  onChange={(e) => setLabStudiesFee(e.target.value)}
                  onFocus={handleFocus}
                  className="form-control form-control-lg"
                />
              </div>
            </div>

            <div className="col-md-3">
              <div className="form-outline mt-3">
                <label>Self Finance Fee</label>
                <input
                  name="self_finance_fee"
                  type="text"
                  value={self_finance_fee}
                  onChange={(e) => setSelfFinanceFee(e.target.value)}
                  onFocus={handleFocus}
                  className="form-control form-control-lg"
                />
              </div>
            </div>

            <div className="col-md-3">
              <div className="form-outline mt-3">
                <label>CME Fund</label>
                <input
                  name="cme_fund"
                  type="text"
                  value={cme_fund}
                  onChange={(e) => setCmeFund(e.target.value)}
                  onFocus={handleFocus}
                  className="form-control form-control-lg"
                />
              </div>
            </div>

            <div className="col-md-3">
              <div className="form-outline mt-3">
                <label>PMC Registration Fee</label>
                <input
                  name="pmc_registration_fee"
                  type="text"
                  value={pmc_registration_fee}
                  onChange={(e) => setPmcRegistrationFee(e.target.value)}
                  onFocus={handleFocus}
                  className="form-control form-control-lg"
                />
              </div>
            </div>

            <div className="col-md-3">
              <div className="form-outline mt-3">
                <label>Fee Discount</label>
                <Dropdown
                  id="fee_discount"
                  name="fee_discount"
                  placeholder="Select Fee Discount "
                  fluid
                  selection
                  value={fee_discount}
                  onChange={(e, { value }) => setFeeDiscount(value)}
                  options={[
                    {
                      key: "",
                      text: "",
                      value: "",
                    },
                    {
                      key: "1",
                      text: "None",
                      value: "None",
                    },
                    {
                      key: "2",
                      text: "Six Monthly Basis (2%)",
                      value: "Six Monthly Basis (2%)",
                    },
                    {
                      key: "3",
                      text: "Annual Basis (4%)",
                      value: "Annual Basis (4%)",
                    },
                  ]}
                />
              </div>
            </div>

            <div className="col-md-3">
              <div className="form-outline mt-3">
                <label>Overseas Tution Fee</label>
                <input
                  name="overseas_tution_fee"
                  type="text"
                  value={overseas_tution_fee}
                  onChange={(e) => setOverseasTutionFee(e.target.value)}
                  onFocus={handleFocus}
                  className="form-control form-control-lg"
                />
              </div>
            </div>

            <div className="col-md-3">
              <div className="form-outline mt-3">
                <label>PBC Registration Fee</label>
                <input
                  name="pbc_registration_fee"
                  type="text"
                  value={pbc_registration_fee}
                  onChange={(e) => setPbcRegistrationFee(e.target.value)}
                  onFocus={handleFocus}
                  className="form-control form-control-lg"
                />
              </div>
            </div>

            <div className="col-md-3">
              <div className="form-outline mt-3">
                <label>Withholding Tax (in %age)</label>
                <input
                  name="withholding_tax"
                  type="text"
                  value={withholding_tax}
                  onChange={(e) => setWithholdingTax(e.target.value)}
                  onFocus={handleFocus}
                  className="form-control form-control-lg"
                />
              </div>
            </div>

            <div className="mt-2">
              <FormControlLabel
                control={
                  <Checkbox
                    checked={withholding_tax_applicable === 1}
                    onChange={handleCheckboxChange}
                  />
                }
                label="Withholding Tax Applicable on Tution Fee Only"
              />
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <Button negative onClick={handleCancelAddFeeStructureModal}>
            Close
          </Button>
          <Button positive onClick={handleOkAddFeeStructureModal}>
            Save
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        fullScreen={fullScreen}
        maxWidth={maxWidth}
        open={showDeleteFeeStructureModal}
        onClose={handleCancelDeleteFeeStructureModal}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">
          {"Delete Fee Structure"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure to delete this Fee Structure?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button negative onClick={handleCancelDeleteFeeStructureModal}>
            Cancel
          </Button>
          <Button positive onClick={handleOkDeleteFeeStructureModal}>
            Done
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        fullScreen={fullScreen}
        maxWidth={maxWidth}
        open={showUpdateFeeStructureModal}
        onClose={handleCancelUpdateFeeStructureModal}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">
          {"Update Fee Structure"}
        </DialogTitle>
        <DialogContent>
          {selectedFeeStructure && (
            <>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-outline mt-3">
                    <label>Campaign</label>
                    <Dropdown
                      id="campaign_id"
                      name="campaign_id"
                      placeholder="Select Campaign"
                      fluid
                      selection
                      value={selectedFeeStructure.campaign_id}
                      onChange={handleUpdateCampaign}
                      options={all_campaigns.map((camp) => ({
                        key: camp.id,
                        text: camp.name,
                        value: camp.id,
                      }))}
                    />
                  </div>
                  <div style={{ color: "red" }}>{formErrors.campaign_id}</div>
                </div>
                <div className="col-md-6"></div>

                <div className="col-md-4">
                  <div className="form-outline mt-3">
                    <label>Campus</label>
                    <Dropdown
                      id="campus_id"
                      name="campus_id"
                      placeholder="Select Campus"
                      fluid
                      selection
                      value={selectedFeeStructure.campus_id}
                      onChange={handleUpdateCampus}
                      options={all_campuses.map((camp) => ({
                        key: camp.id,
                        text: camp.name,
                        value: camp.id,
                      }))}
                    />
                  </div>
                  <div style={{ color: "red" }}>{formErrors.campus_id}</div>
                </div>

                <div className="col-md-4">
                  <div className="form-outline mt-3">
                    <label>Departments</label>
                    <Dropdown
                      id="department_id"
                      name="department_id"
                      placeholder="Select Department"
                      fluid
                      selection
                      value={selectedFeeStructure.department_id}
                      onChange={handleUpdateDepartment}
                      options={all_departments.map((dept) => ({
                        key: dept.id,
                        text: dept.department_name,
                        value: dept.department_id,
                      }))}
                    />
                  </div>
                  <div style={{ color: "red" }}>{formErrors.department_id}</div>
                </div>

                <div className="col-md-4">
                  <div className="form-outline mt-3">
                    <label>Degrees</label>
                    <Dropdown
                      id="degree_id"
                      name="degree_id"
                      placeholder="Select Degree"
                      fluid
                      selection
                      value={selectedFeeStructure.degree_id}
                      onChange={handleUpdateDegree}
                      options={all_degrees.map((deg) => ({
                        key: deg.id,
                        text: deg.program_name,
                        value: deg.id,
                      }))}
                    />
                  </div>
                  <div style={{ color: "red" }}>{formErrors.degree_id}</div>
                </div>

                <div className="col-md-4">
                  <div className="form-outline mt-3">
                    <label>Collection Bank Account</label>
                    <Dropdown
                      id="degree_id"
                      name="degree_id"
                      placeholder="Select Degree"
                      fluid
                      selection
                      value={selectedFeeStructure.degree_id}
                      onChange={(e) =>
                        setSelectedFeeStructure({
                          ...selectedFeeStructure,
                          degree_id: e.target.value,
                        })
                      }
                      options={all_degrees.map((deg) => ({
                        key: deg.id,
                        text: deg.program_name,
                        value: deg.id,
                      }))}
                    />
                  </div>
                  <div style={{ color: "red" }}>{formErrors.degree_id}</div>
                </div>

                <div className="col-md-4">
                  <div className="form-outline mt-3">
                    <label>Currency</label>
                    <Dropdown
                      id="currency_id"
                      name="currency_id"
                      placeholder="Select Currency"
                      fluid
                      selection
                      value={selectedFeeStructure.currency_id}
                      onChange={(e) =>
                        selectedFeeStructure({
                          ...selectedFeeStructure,
                          currency_id: e.target.value,
                        })
                      }
                      options={all_currencies.map((curr) => ({
                        key: curr.id,
                        text: curr.symbol + " " + curr.code + " - " + curr.name,
                        value: curr.id,
                      }))}
                    />
                  </div>
                  <div style={{ color: "red" }}>{formErrors.currency_id}</div>
                </div>

                <div className="col-md-4">
                  <div className="form-outline mt-3">
                    <label>Program Type</label>
                    <Dropdown
                      id="program_type"
                      name="program_type"
                      placeholder="Select Program Type "
                      fluid
                      selection
                      value={selectedFeeStructure.program_type}
                      onChange={(e) =>
                        setSelectedFeeStructure({
                          ...selectedFeeStructure,
                          program_type: e.target.value,
                        })
                      }
                      options={[
                        {
                          key: "",
                          text: "",
                          value: "",
                        },
                        {
                          key: "1",
                          text: "Semester",
                          value: "Semester",
                        },
                        {
                          key: "2",
                          text: "Annual",
                          value: "Annual",
                        },
                        {
                          key: "3",
                          text: "Medical",
                          value: "Medical",
                        },
                        {
                          key: "4",
                          text: "Certificate",
                          value: "Certificate",
                        },
                      ]}
                    />
                    <div style={{ color: "red" }}>
                      {formErrors.program_type}
                    </div>
                  </div>
                </div>

                <div className="col-md-4">
                  <div className="form-outline mt-3">
                    <label>Fee Structure Type</label>
                    <Dropdown
                      id="fee_structure_type"
                      name="fee_structure_type"
                      placeholder="Select Fee Structure Type "
                      fluid
                      selection
                      value={selectedFeeStructure.fee_structure_type}
                      onChange={(e) =>
                        setSelectedFeeStructure({
                          ...selectedFeeStructure,
                          fee_structure_type: e.target.value,
                        })
                      }
                      options={[
                        {
                          key: "",
                          text: "",
                          value: "",
                        },
                        {
                          key: "1",
                          text: "Local",
                          value: "Local",
                        },
                        {
                          key: "2",
                          text: "International",
                          value: "International",
                        },
                      ]}
                    />
                    <div style={{ color: "red" }}>
                      {formErrors.fee_structure_type}
                    </div>
                  </div>
                </div>

                <div className="col-md-4">
                  <div className="form-outline mt-3">
                    <label>Admission Category</label>
                    <Dropdown
                      id="admission_category"
                      name="admission_category"
                      placeholder="Select Admission Category "
                      fluid
                      selection
                      value={selectedFeeStructure.admission_category}
                      onChange={(e) =>
                        setSelectedFeeStructure({
                          ...selectedFeeStructure,
                          admission_category: e.target.value,
                        })
                      }
                      options={[
                        {
                          key: "",
                          text: "",
                          value: "",
                        },
                        {
                          key: "1",
                          text: "Regular",
                          value: "Regular",
                        },
                        {
                          key: "2",
                          text: "Self Finance",
                          value: "Self Finance",
                        },
                        {
                          key: "3",
                          text: "International",
                          value: "International",
                        },
                        {
                          key: "4",
                          text: "Other Quota",
                          value: "Other Quota",
                        },
                      ]}
                    />
                    <div style={{ color: "red" }}>
                      {formErrors.admission_category}
                    </div>
                  </div>
                </div>

                <div className="col-md-4">
                  <div className="form-outline mt-3">
                    <label>Admission Sub-Category</label>
                    <Dropdown
                      id="admission_sub_category"
                      name="admission_sub_category"
                      placeholder="Select Admission Sub-Category "
                      fluid
                      selection
                      value={selectedFeeStructure.admission_sub_category}
                      onChange={(e) =>
                        setSelectedFeeStructure({
                          ...selectedFeeStructure,
                          admission_sub_category: e.target.value,
                        })
                      }
                      options={[
                        {
                          key: "",
                          text: "",
                          value: "",
                        },
                        {
                          key: "1",
                          text: "Medical Graduate",
                          value: "Medical Graduate",
                        },
                        {
                          key: "2",
                          text: "PMDC",
                          value: "PMDC",
                        },
                        {
                          key: "3",
                          text: "HEC-Afghan",
                          value: "HEC-Afghan",
                        },
                        {
                          key: "4",
                          text: "NSCE",
                          value: "NSCE",
                        },
                        {
                          key: "5",
                          text: "SBSC",
                          value: "SBSC",
                        },
                        {
                          key: "6",
                          text: "Sports",
                          value: "Sports",
                        },
                      ]}
                    />
                    <div style={{ color: "red" }}>
                      {formErrors.admission_sub_category}
                    </div>
                  </div>
                </div>

                <div className="col-md-3">
                  <div className="form-outline mt-3">
                    <label>No Of Courses</label>
                    <input
                      name="no_of_courses"
                      type="text"
                      value={selectedFeeStructure.no_of_courses}
                      onChange={(e) =>
                        setSelectedFeeStructure({
                          ...selectedFeeStructure,
                          no_of_courses: e.target.value,
                        })
                      }
                      onFocus={handleFocus}
                      className="form-control form-control-lg"
                    />
                  </div>
                  <div style={{ color: "red" }}>{formErrors.no_of_courses}</div>
                </div>

                <div className="col-md-3">
                  <div className="form-outline mt-3">
                    <label>Total Cr.Hours</label>
                    <input
                      name="total_credit_hours"
                      type="text"
                      value={selectedFeeStructure.total_credit_hours}
                      onChange={(e) =>
                        setSelectedFeeStructure({
                          ...selectedFeeStructure,
                          total_credit_hours: e.target.value,
                        })
                      }
                      onFocus={handleFocus}
                      className="form-control form-control-lg"
                    />
                  </div>
                  <div style={{ color: "red" }}>
                    {formErrors.total_credit_hours}
                  </div>
                </div>

                <div className="col-md-3">
                  <div className="form-outline mt-3">
                    <label>Admission Fee</label>
                    <input
                      name="admission_fee"
                      type="text"
                      value={selectedFeeStructure.admission_fee}
                      onChange={(e) =>
                        setSelectedFeeStructure({
                          ...selectedFeeStructure,
                          admission_fee: e.target.value,
                        })
                      }
                      onFocus={handleFocus}
                      className="form-control form-control-lg"
                    />
                  </div>
                  <div style={{ color: "red" }}>{formErrors.admission_fee}</div>
                </div>

                <div className="col-md-3">
                  <div className="form-outline mt-3">
                    <label>Registration Fee</label>
                    <input
                      name="registration_fee"
                      type="text"
                      value={selectedFeeStructure.registration_fee}
                      onChange={(e) =>
                        setSelectedFeeStructure({
                          ...selectedFeeStructure,
                          registration_fee: e.target.value,
                        })
                      }
                      onFocus={handleFocus}
                      className="form-control form-control-lg"
                    />
                  </div>
                  <div style={{ color: "red" }}>
                    {formErrors.registration_fee}
                  </div>
                </div>

                <div className="col-md-3">
                  <div className="form-outline mt-3">
                    <label>Tution Fee Per Cr.Hour</label>
                    <input
                      name="tution_fee_per_credit_hour"
                      type="text"
                      value={selectedFeeStructure.tution_fee_per_credit_hour}
                      onChange={(e) =>
                        setSelectedFeeStructure({
                          ...selectedFeeStructure,
                          tution_fee_per_credit_hour: e.target.value,
                        })
                      }
                      onFocus={handleFocus}
                      className="form-control form-control-lg"
                    />
                  </div>
                  <div style={{ color: "red" }}>
                    {formErrors.tution_fee_per_credit_hour}
                  </div>
                </div>

                <div className="col-md-3">
                  <div className="form-outline mt-3">
                    <label>Enrollment Fee Per Course</label>
                    <input
                      name="enrollment_fee_per_course"
                      type="text"
                      value={selectedFeeStructure.enrollment_fee_per_course}
                      onChange={(e) =>
                        setSelectedFeeStructure({
                          ...selectedFeeStructure,
                          enrollment_fee_per_course: e.target.value,
                        })
                      }
                      onFocus={handleFocus}
                      className="form-control form-control-lg"
                    />
                  </div>
                  <div style={{ color: "red" }}>
                    {formErrors.enrollment_fee_per_course}
                  </div>
                </div>

                <div className="col-md-3">
                  <div className="form-outline mt-3">
                    <label>University Admin Charges</label>
                    <input
                      name="university_admin_charges"
                      type="text"
                      value={selectedFeeStructure.university_admin_charges}
                      onChange={(e) =>
                        setSelectedFeeStructure({
                          ...selectedFeeStructure,
                          university_admin_charges: e.target.value,
                        })
                      }
                      onFocus={handleFocus}
                      className="form-control form-control-lg"
                    />
                  </div>
                  <div style={{ color: "red" }}>
                    {formErrors.university_admin_charges}
                  </div>
                </div>

                <div className="col-md-3">
                  <div className="form-outline mt-3">
                    <label>Examination Fee Per Course</label>
                    <input
                      name="examination_fee_per_course"
                      type="text"
                      value={selectedFeeStructure.examination_fee_per_course}
                      onChange={(e) =>
                        setSelectedFeeStructure({
                          ...selectedFeeStructure,
                          examination_fee_per_course: e.target.value,
                        })
                      }
                      onFocus={handleFocus}
                      className="form-control form-control-lg"
                    />
                  </div>
                  <div style={{ color: "red" }}>
                    {formErrors.examination_fee_per_course}
                  </div>
                </div>

                <div className="col-md-3">
                  <div className="form-outline mt-3">
                    <label>Medical Examination Fee</label>
                    <input
                      name="medical_examination_fee"
                      type="text"
                      value={selectedFeeStructure.medical_examination_fee}
                      onChange={(e) =>
                        setSelectedFeeStructure({
                          ...selectedFeeStructure,
                          medical_examination_fee: e.target.value,
                        })
                      }
                      onFocus={handleFocus}
                      className="form-control form-control-lg"
                    />
                  </div>
                  <div style={{ color: "red" }}>
                    {formErrors.medical_examination_fee}
                  </div>
                </div>

                <div className="col-md-3">
                  <div className="form-outline mt-3">
                    <label>Societies & Club Fee</label>
                    <input
                      name="societies_clubs_fee"
                      type="text"
                      value={selectedFeeStructure.societies_clubs_fee}
                      onChange={(e) =>
                        setSelectedFeeStructure({
                          ...selectedFeeStructure,
                          societies_clubs_fee: e.target.value,
                        })
                      }
                      onFocus={handleFocus}
                      className="form-control form-control-lg"
                    />
                  </div>
                  <div style={{ color: "red" }}>
                    {formErrors.societies_clubs_fee}
                  </div>
                </div>

                <div className="col-md-3">
                  <div className="form-outline mt-3">
                    <label>Medical Diagnosis Charges</label>
                    <input
                      name="medical_diagnosis_charges"
                      type="text"
                      value={selectedFeeStructure.medical_diagnosis_charges}
                      onChange={(e) =>
                        setSelectedFeeStructure({
                          ...selectedFeeStructure,
                          medical_diagnosis_charges: e.target.value,
                        })
                      }
                      onFocus={handleFocus}
                      className="form-control form-control-lg"
                    />
                  </div>
                  <div style={{ color: "red" }}>
                    {formErrors.medical_diagnosis_charges}
                  </div>
                </div>

                <div className="col-md-3">
                  <div className="form-outline mt-3">
                    <label>Co-curricular Activities Fee</label>
                    <input
                      name="cocurricular_activities_fee"
                      type="text"
                      value={selectedFeeStructure.cocurricular_activities_fee}
                      onChange={(e) =>
                        setSelectedFeeStructure({
                          ...selectedFeeStructure,
                          cocurricular_activities_fee: e.target.value,
                        })
                      }
                      onFocus={handleFocus}
                      className="form-control form-control-lg"
                    />
                  </div>
                  <div style={{ color: "red" }}>
                    {formErrors.cocurricular_activities_fee}
                  </div>
                </div>

                <div className="col-md-3">
                  <div className="form-outline mt-3">
                    <label>Lab Studies Fee</label>
                    <input
                      name="lab_studies_fee"
                      type="text"
                      value={selectedFeeStructure.lab_studies_fee}
                      onChange={(e) =>
                        setSelectedFeeStructure({
                          ...selectedFeeStructure,
                          lab_studies_fee: e.target.value,
                        })
                      }
                      onFocus={handleFocus}
                      className="form-control form-control-lg"
                    />
                  </div>
                </div>

                <div className="col-md-3">
                  <div className="form-outline mt-3">
                    <label>Self Finance Fee</label>
                    <input
                      name="self_finance_fee"
                      type="text"
                      value={selectedFeeStructure.self_finance_fee}
                      onChange={(e) =>
                        setSelectedFeeStructure({
                          ...selectedFeeStructure,
                          self_finance_fee: e.target.value,
                        })
                      }
                      onFocus={handleFocus}
                      className="form-control form-control-lg"
                    />
                  </div>
                </div>

                <div className="col-md-3">
                  <div className="form-outline mt-3">
                    <label>CME Fund</label>
                    <input
                      name="cme_fund"
                      type="text"
                      value={selectedFeeStructure.cme_fund}
                      onChange={(e) =>
                        setSelectedFeeStructure({
                          ...selectedFeeStructure,
                          cme_fund: e.target.value,
                        })
                      }
                      onFocus={handleFocus}
                      className="form-control form-control-lg"
                    />
                  </div>
                </div>

                <div className="col-md-3">
                  <div className="form-outline mt-3">
                    <label>PMC Registration Fee</label>
                    <input
                      name="pmc_registration_fee"
                      type="text"
                      value={selectedFeeStructure.pmc_registration_fee}
                      onChange={(e) =>
                        setSelectedFeeStructure({
                          ...selectedFeeStructure,
                          pmc_registration_fee: e.target.value,
                        })
                      }
                      onFocus={handleFocus}
                      className="form-control form-control-lg"
                    />
                  </div>
                </div>

                <div className="col-md-3">
                  <div className="form-outline mt-3">
                    <label>Fee Discount</label>
                    <Dropdown
                      id="fee_discount"
                      name="fee_discount"
                      placeholder="Select Fee Discount "
                      fluid
                      selection
                      value={selectedFeeStructure.fee_discount}
                      onChange={(e) =>
                        setSelectedFeeStructure({
                          ...selectedFeeStructure,
                          fee_discount: e.target.value,
                        })
                      }
                      options={[
                        {
                          key: "",
                          text: "",
                          value: "",
                        },
                        {
                          key: "1",
                          text: "None",
                          value: "None",
                        },
                        {
                          key: "2",
                          text: "Six Monthly Basis (2%)",
                          value: "Six Monthly Basis (2%)",
                        },
                        {
                          key: "3",
                          text: "Annual Basis (4%)",
                          value: "Annual Basis (4%)",
                        },
                      ]}
                    />
                  </div>
                </div>

                <div className="col-md-3">
                  <div className="form-outline mt-3">
                    <label>Overseas Tution Fee</label>
                    <input
                      name="overseas_tution_fee"
                      type="text"
                      value={selectedFeeStructure.overseas_tution_fee}
                      onChange={(e) =>
                        setSelectedFeeStructure({
                          ...selectedFeeStructure,
                          overseas_tution_fee: e.target.value,
                        })
                      }
                      onFocus={handleFocus}
                      className="form-control form-control-lg"
                    />
                  </div>
                </div>

                <div className="col-md-3">
                  <div className="form-outline mt-3">
                    <label>PBC Registration Fee</label>
                    <input
                      name="pbc_registration_fee"
                      type="text"
                      value={selectedFeeStructure.pbc_registration_fee}
                      onChange={(e) =>
                        setSelectedFeeStructure({
                          ...selectedFeeStructure,
                          pbc_registration_fee: e.target.value,
                        })
                      }
                      onFocus={handleFocus}
                      className="form-control form-control-lg"
                    />
                  </div>
                </div>

                <div className="col-md-3">
                  <div className="form-outline mt-3">
                    <label>Withholding Tax (in %age)</label>
                    <input
                      name="withholding_tax"
                      type="text"
                      value={selectedFeeStructure.withholding_tax}
                      onChange={(e) =>
                        setSelectedFeeStructure({
                          ...selectedFeeStructure,
                          withholding_tax: e.target.value,
                        })
                      }
                      onFocus={handleFocus}
                      className="form-control form-control-lg"
                    />
                  </div>
                </div>

                <div className="mt-2">
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={
                          selectedFeeStructure.withholding_tax_applicable === 1
                        }
                        onChange={handleUpdateCheckboxChange}
                      />
                    }
                    label="Withholding Tax Applicable on Tution Fee Only"
                  />
                </div>
              </div>
            </>
          )}
        </DialogContent>
        <DialogActions>
          <Button negative onClick={handleCancelUpdateFeeStructureModal}>
            Close
          </Button>
          <Button positive onClick={handleOkUpdateFeeStructureModal}>
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </DashboardLayout>
  );
}

export default FeeStructure;
